
import React, { useEffect, useState } from "react";
import Job, { techHasCalled } from "../models/Job";
import FlexRow from "../../../../components/base/FlexRow";
import Icon from "../../../../components/base/Icon";
import PerCallDuplicateBadge from "./PerCallDuplicateBadge";
import Timer from "../../../../components/timer/Timer";
import Clock from "../../../../components/timer/Clock";
import { Link, useNavigate } from "react-router-dom";
import { createJob, deleteJobOpen, getUser, hasRole, isDarkMode, isDemo, openArchiveJob, openCopyJob, openJobQuickView, opennotCalledActions, rejectJobByTech, removeJob, toAppointmentDate, toPrettyDate, useChatList, useGlobal, useHub, usePreferences, useScreen, useSocket, useStatusesForJob, useHasMaskedJobCalls } from "../../../../core/Global";
import { toastError } from "../../../../components/base/Toast";
import { API_ROUTES } from "../../../../core/Constants";
import JobStatus from "../../base/models/JobStatus";
import Avatar from "../../../../components/base/Avatar";
import DropdownMenu from "../../../../components/menu/DropdownMenu";
import { convertTo12HourFormat, copyToClipboard } from "../../../../core/Helper";
import Time from "../../../../components/timer/Time";
import { TimeFormats, UserTypes } from "../../../../core/Enums";
import IconButton from "../../../../components/base/IconButton";
import JobColorPicker from "./JobColorPicker";
import { canPaintJob, jobColorOf, jobColorVars } from "./JobColor";
import "./JobColor.css";

interface IProps {
    job: Job
    onQuickView?: (job: Job) => void
    onUpdateAddress?: (job: Job) => void
    onUpdateTech?: (job: Job) => void
    onUpdateAppointment?: (job: Job) => void
    onUpdateStatusAppointment?: (job: Job) => void
    onUpdateStatus?: (job: Job) => void
    onUpdateStatusNote?: (job: Job, st: JobStatus) => void
    onSendJob?: (job: Job) => void
    onManageTechResponse?: (job: Job, s: number) => void
    onViewNotes?: (job: Job) => void
    onOpenAttachments?: (job: Job) => void
    onViewTasks?: (job: Job) => void
    onEdit?: (job: Job) => void
    onCloseJob?: (job: Job, callback: () => void) => void
    onInProgressError?: (err: string) => void
    onReopenFromClosed?: (job: Job, st: JobStatus) => void
}
const JobDataCard = (props: IProps) => {

    const hub = useHub();
    // Whether there is a proxy number to show at all.
    const maskedAllowed = useHasMaskedJobCalls()
    const user = getUser();
    const navigate = useNavigate();


    const screen = useScreen();
    const [compact, compactSet] = useState<boolean>(false)
    useEffect(() => {
        if (screen.width < 1500) compactSet(true)
        else compactSet(false)
    }, [screen])




    const [statusUpdating, statusUpdatingSet] = useState<boolean>(false);

    const [jobSentTime, jobSentTimeSet] = useState<number>(0);
    const [jobSentColor, jobSentColorSet] = useState<string>("success");

    const [HasAttachments, HasAttachmentsSet] = useState<boolean>(false);
    const [HasTasks, HasTasksSet] = useState<boolean>(false);

    const [techAcceptedTotalSeconds, techAcceptedTotalSecondsSet] = useState<number>(0);

    useEffect(() => {
        if (props.job) {
            var HasAttachments = false;
            var hasTasks = false;

            if (props.job.attachmentsCount && props.job.attachmentsCount > 0 && props.job.usersSeenAttachments && user?.id && props.job.usersSeenAttachments.indexOf(user.id) < 0) HasAttachments = true;
            if (props.job.tasksCount && props.job.tasksCount > 0 && props.job.usersSeenTasks && user?.id && props.job.usersSeenTasks.indexOf(user.id) < 0) hasTasks = true;


            HasAttachmentsSet(HasAttachments);
            HasTasksSet(hasTasks);


            props.job.flags?.forEach(f => {
                window.createBootstrapTooltip(`job-flags-${props.job.id}-${f.id}`);
            });

            window.createBootstrapTooltip(`job-tags-${props.job.id}`)



        }
    }, [props.job])

    useEffect(() => {

        // Without masked calls the job went out with the direct number: no call to wait for.
        if (props.job.techAccepted && !props.job.ignoreNotCalledAlert && maskedAllowed) {

            var i = props.job.techAcceptedTotalSeconds ?? 0;
            techAcceptedTotalSecondsSet(i);

            const callIntv = setInterval(() => {
                techAcceptedTotalSecondsSet(t => t + 1);
            }, 1000);

            return () => {
                clearInterval(callIntv);
            }
        }

    }, [props.job, maskedAllowed])





    useEffect(() => {
        const element = document.getElementById(`job_${props.job.id}_slider`);
        if (element) {
            const carousel = new (window as any).bootstrap.Carousel(element, {
                touch: true,
                ride: false,
                interval: false,
                wrap: true
            });
        }
    }, []);


    const [accepting, acceptingSet] = useState<boolean>(false)

    const jobColor = jobColorOf(props.job, user?.isTech)
    const canPaint = canPaintJob(props.job, user?.isTech, hasRole("EditArchivedJobs"))

    return (
        <div id={`job_${props.job.id}_slider`} data-bs-touch="true"
            className={`card carousel carousel-custom carousel-stretch slide mt-5${jobColor ? " job-colored job-colored-card" : ""}`}
            style={jobColorVars(jobColor)}>

            {
                // Only when the job actually has a colour: unlike the board there's no hover on
                // touch, so an empty lane would just be an invisible tap target. The droplet in
                // the card footer is the way to paint an uncoloured job here.
                jobColor &&
                (canPaint
                    ? <JobColorPicker job={props.job} variant="spine" />
                    : <span className="color-selector-spine is-static" style={{ backgroundColor: jobColor }} />)
            }

            <div className="card-body p-5 pt-3" onClick={e => {
                if (props.onQuickView) props.onQuickView(props.job);
            }}>

                <FlexRow className="mb-3">
                    <div className="fs-5" style={{ fontWeight: 200 }}>
                        #{props.job.jobId}
                    </div>
                    <ol className="p-0 m-0 carousel-indicators carousel-indicators-bullet carousel-indicators-active-primary ms-auto">
                        <li data-bs-target={`#job_${props.job.id}_slider`} data-bs-slide-to="0" className="active ms-1"></li>
                        <li data-bs-target={`#job_${props.job.id}_slider`} data-bs-slide-to="1" className="ms-1"></li>
                        {
                            !window.isNullOrEmpty(props.job.jobDetails) &&
                            <li data-bs-target={`#job_${props.job.id}_slider`} data-bs-slide-to="2" className="ms-1"></li>
                        }

                    </ol>
                </FlexRow>

                <div className="carousel-inner" style={{
                    height: user?.userType == UserTypes.Technician ? 70 : 85,
                    minHeight: user?.userType == UserTypes.Technician ? 70 : 85
                }}>
                    <div className="carousel-item active show">
                        <FlexRow className="text-gray-700 mb-2">
                            <FlexRow className="me-5">
                                <Icon icon="user" type="solid" size={11} className="me-1" />
                                <span className="fs-8 limited-text w-50px">{props.job.fullName}</span>
                            </FlexRow>
                            {
                                // For a technician, don't reveal the customer's number until they
                                // accept the job (even when direct calling is allowed).
                                (!user?.isTech || (props.job.ignoreNotCalledText?.toLowerCase().includes("direct") && props.job.techAccepted)) &&
                                <FlexRow>
                                    <Icon icon="phone-rotary" type="solid" size={11} className="me-1" />
                                    <span className="fs-8">{props.job.phone?.phoneFriendly}{window.isNullOrEmpty(props.job.phone?.extension) ? "" : " , " + props.job.phone?.extension}</span>
                                </FlexRow>
                            }

                        </FlexRow>
                        <FlexRow className="text-gray-700 mb-2">
                            <FlexRow>
                                <Icon icon="location-dot" type="solid" size={11} className="me-1" />
                                <span className="fs-8 limited-text w-100" title={props.job.address?.title}>{props.job.address?.title}</span>
                            </FlexRow>
                        </FlexRow>

                        {
                            props.job.isCanceled ?
                                <FlexRow className="text-gray-700 mb-2">
                                    <FlexRow className="text-danger me-5">
                                        <Icon icon="circle-info" size={11} className="me-1" />
                                        <span className="fs-8">{props.job.lastStatusNote}</span>
                                    </FlexRow>
                                </FlexRow>
                                :
                                <FlexRow className="text-gray-700 mb-2">
                                    <FlexRow className="text-gray-700 me-5">
                                        <Icon icon="wrench" type="solid" size={11} className="me-1" />
                                        <span className="fs-8 limited-text w-100px" title={props.job.jobType}>{props.job.jobType}</span>
                                    </FlexRow>
                                    {
                                        !user?.isTech &&
                                        <FlexRow className="text-gray-700">
                                            <Icon icon="bullhorn" type="solid" size={11} className="me-1" />
                                            <span className="fs-8">{props.job.jobSource}</span>
                                        </FlexRow>
                                    }

                                </FlexRow>
                        }


                        {
                            !user?.isTech &&
                            <FlexRow className="mb-2">
                                <PerCallDuplicateBadge job={props.job} />
                                {
                                    props.job.flags?.map(flag =>
                                        <span className="badge badge-danger me-1"
                                            style={{ backgroundColor: flag.color }}>
                                            <Icon icon="flag" size={10} type="solid" className="me-1" />
                                            <span className="limited-text mw-75px">
                                                {flag.name}
                                            </span>
                                        </span>
                                    )
                                }
                                {
                                    props.job.tags?.map(tag =>
                                        <span key={`job-${props.job.id}-flag-${tag.id}`}
                                            className="badge badge-secondary me-1 mb-1"
                                            style={{
                                                backgroundColor: isDarkMode() ? undefined : "rgb(227 227 231)"
                                            }}>
                                            <Icon icon="tag" size={10} type="solid" className="me-1" />
                                            <span className="limited-text mw-75px">
                                                {tag.name}
                                            </span>
                                        </span>
                                    )
                                }
                            </FlexRow>
                        }




                    </div>
                    <div className="carousel-item">
                        <FlexRow className="text-gray-700 mb-2">
                            <FlexRow className="text-gray-700 me-10">
                                <Icon icon="user-helmet-safety" type="solid" size={11} className="me-1" />
                                {
                                    props.job.tech ?
                                        <span className="fs-8 limited-text w-125px" title={props.job.tech?.fullName}>{props.job.tech?.fullName}</span>
                                        :
                                        <span className="fs-9 text-muted">No Technician</span>
                                }

                            </FlexRow>
                            <FlexRow className="text-gray-700">
                                <Icon icon="map" type="solid" size={11} className="me-1" />
                                {
                                    props.job.tech ?
                                        <span className="fs-8 limited-text w-100px" title={props.job.metroName}>{props.job.metroName}</span>
                                        :
                                        <span className="fs-9 text-muted">No Metro</span>
                                }
                            </FlexRow>
                        </FlexRow>

                        <FlexRow className="mb-2">
                            <FlexRow className="text-gray-700 me-10" title="Appointment Date">
                                <Icon icon="calendar-clock" type="solid" size={11} className="me-1" />
                                {
                                    props.job.appointmentDate ?
                                        <span className="fs-8">{toPrettyDate(props.job.appointmentFrom, props.job.timezoneOffset)}</span>
                                        :
                                        <span className="fs-9 text-muted">No Appintment</span>
                                }
                            </FlexRow>

                        </FlexRow>


                        <FlexRow className="text-gray-700 mb-2" title="Local Time">
                            {
                                props.job.stateId && props.job.timezone ?
                                    <>
                                        <div className="fs-8 me-1">
                                            <Icon icon="clock" className="me-1" size={11} />
                                            <Clock offset={props.job.timezoneOffset} />
                                        </div>
                                        <div className="text-muted fs-9">
                                            ({props.job.timezone})
                                        </div>
                                    </>
                                    :
                                    <>
                                        <Icon icon="clock" className="me-1" size={11} />
                                        <span>-</span>
                                    </>
                            }
                        </FlexRow>
                    </div>

                </div>




            </div>

            {
                user?.userType == UserTypes.Technician &&
                <div className="card-footer p-5 pt-2 pb-2">
                    {
                        props.job.jobStatusId == "pending" ?
                            <FlexRow>
                                <FlexRow className={"text-" + jobSentColor}>
                                    <Icon icon="timer" className="me-1" />
                                    <Timer baseDate={props.job.sentToTechAt}
                                        onTick={t => {
                                            jobSentColorSet(t < 60 ? "success" : t < 120 ? "warning" : "danger");
                                            jobSentTimeSet(t);
                                        }} />
                                </FlexRow>
                                <FlexRow className="ms-auto">
                                    <button className="btn btn-success btn-sm me-2"
                                        disabled={accepting}
                                        onClick={e => {
                                            e.preventDefault()
                                            acceptingSet(true)
                                            hub.Post(API_ROUTES.Jobs + "acceptbytech", {
                                                id: props.job.id
                                            }, res => {
                                                acceptingSet(false)
                                                if (!res.success) {
                                                    // Reassigned while the app was backgrounded — drop it from the board.
                                                    toastError(res.message ?? "This job is no longer assigned to you.")
                                                    removeJob(props.job)
                                                }
                                            })
                                        }}>
                                        {
                                            accepting ?
                                                <>
                                                    <Icon icon="spinner-third" spin />
                                                    <span className="ms-2">Please wait...</span>
                                                </>
                                                :
                                                <>Accept Job</>
                                        }

                                    </button>
                                    <button className="btn btn-light-danger btn-sm"
                                        disabled={accepting}
                                        onClick={e => {
                                            e.preventDefault()
                                            rejectJobByTech(props.job)

                                        }}>
                                        Reject Job
                                    </button>
                                </FlexRow>
                            </FlexRow>
                            :
                            <FlexRow>
                                <FlexRow>

                                    {
                                        techHasCalled(props.job) ?
                                            <FlexRow>
                                                <Icon icon="phone-circle" className="text-success me-1" type="solid" />
                                                <span className="text-success fs-7" style={{ marginTop: 1 }}>Already Called!</span>
                                            </FlexRow>
                                            : props.job.creatorUserId == props.job.techId ?
                                                <FlexRow className="mt-1">
                                                    <Icon icon="user-helmet-safety" className="text-info me-1" type="solid" />
                                                    <span className="text-info fs-7" style={{ marginTop: 1 }}>Added By Tech</span>
                                                </FlexRow>
                                                : (props.job.ignoreNotCalledAlert || !maskedAllowed) ?
                                                    <FlexRow>
                                                        <Icon icon="phone-circle" className="text-info me-1" type="solid" />
                                                        <span className="text-info fs-7" style={{ marginTop: 1 }}>{props.job.ignoreNotCalledAlert ? props.job.ignoreNotCalledText : "Direct Given!"}</span>
                                                    </FlexRow>
                                                    : techAcceptedTotalSeconds > 300 ?
                                                        <FlexRow title="Technician call delayed!" className="blinking-text" onClick={() => {
                                                            if (user?.userType == UserTypes.Technician) return;
                                                            opennotCalledActions(props.job)
                                                        }}>
                                                            <Icon icon="phone-slash" className="text-danger me-1" type="solid" />
                                                            <span className="text-danger fs-7 me-2" style={{ marginTop: 1 }}>
                                                                Not Called!
                                                            </span>
                                                            <span className="text-danger fs-8" style={{ marginTop: 2 }}>
                                                                <Time totalSeconds={techAcceptedTotalSeconds} />
                                                            </span>
                                                        </FlexRow>
                                                        : techAcceptedTotalSeconds > 100 ?
                                                            <FlexRow title="Technician call delayed!" className="mt-1" onClick={() => {
                                                                if (user?.userType == UserTypes.Technician) return;
                                                                opennotCalledActions(props.job)
                                                            }}>
                                                                <Icon icon="phone-slash" className="text-warning me-1" type="solid" />
                                                                <span className="text-warning fs-7 me-2" style={{ marginTop: 1 }}>
                                                                    Not Called!
                                                                </span>
                                                                <span className="text-warning fs-8" style={{ marginTop: 1.5 }}>
                                                                    <Time totalSeconds={techAcceptedTotalSeconds} />
                                                                </span>
                                                            </FlexRow>
                                                            :
                                                            <FlexRow title="Technician has accepted the job!" className="mt-1">
                                                                <Icon icon="check-circle" className="text-success me-1" type="solid" />
                                                                <span className="text-success fs-7" style={{ marginTop: 1 }}>Accepted</span>
                                                            </FlexRow>
                                    }

                                </FlexRow>
                                <FlexRow className="ms-auto">
                                    {/* {
                                        props.job.ignoreNotCalledText?.toLowerCase().includes("direct") ?
                                            <a href={`tel:${props.job.phoneRaw}${window.isNullOrEmpty(props.job.phone?.extension) ? "" : " , " + props.job.phone?.extension}`} className="btn btn-light-primary btn-active-light-primary btn-sm">
                                                <Icon icon="phone" type="solid" />
                                                <span>Call Customer</span>
                                            </a>
                                            : <></>
                                        // <a href={`tel:${proxyLineRaw},${props.job.sentPasscode}`} className="btn btn-light-primary btn-active-light-primary btn-sm">
                                        //     <Icon icon="phone" type="solid" />
                                        //     <span>Call Customer</span>
                                        // </a>
                                    } */}

                                </FlexRow>
                            </FlexRow>
                    }


                </div>
            }

            {
                user?.userType != UserTypes.Technician &&
                <div className="card-footer p-5 pt-2 pb-2">
                    <FlexRow>
                        <div>
                            <FlexRow>
                                <a href="#" title="Job Status"
                                    data-kt-menu-trigger="click" data-kt-menu-placement="bottom-start"
                                    onClick={e => {
                                        e.preventDefault();
                                    }}>
                                    {
                                        statusUpdating ?
                                            <Icon icon="circle-notch" type="solid" spin color={props.job.jobStatus?.color} size={12} />
                                            :
                                            <Icon icon="circle" type="solid" color={props.job.jobStatus?.color} size={12} />
                                    }
                                </a>
                                <span className={`fs-8 ms-1`} style={{ width: 60 }}>
                                    <Timer key={props.job.id} baseDate={props.job.lastStatusUpdatedAt} short />
                                </span>
                            </FlexRow>
                        </div>

                        <div className="ms-auto">
                            <a href="#" className="px-4 py-5 position-relative"
                                data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end"
                                onClick={e => {
                                    e.preventDefault();
                                    window.dataTableMenu();
                                }}>
                                <Icon icon="ellipsis-vertical" type="regular" className="text-dark" size={compact ? 14 : 16} />
                            </a>
                            <DropdownMenu width={200} source={[
                                {
                                    title: "Archive Job",
                                    icon: "archive",
                                    visible: props.job.isClosed || props.job.isCanceled,
                                    action() {
                                        openArchiveJob(props.job)
                                    },
                                },
                                {
                                    title: "View Job Details",
                                    icon: "eye",
                                    to: "/crm/jobs/overview/" + props.job.id
                                },
                                {
                                    title: "Estimates",
                                    icon: "file-invoice-dollar",
                                    action() {
                                        navigate("/crm/jobs/estimates/" + props.job.id)
                                    }
                                },
                                {
                                    title: "Invoices",
                                    icon: "file-invoice-dollar",
                                    action() {
                                        navigate("/crm/jobs/invoices/" + props.job.id)
                                    }
                                },
                                {
                                    title: "Attachments",
                                    icon: "paperclip-vertical",
                                    visible: !props.job.isClosed && !props.job.isCanceled,
                                    action() {
                                        if (props.onOpenAttachments) props.onOpenAttachments(props.job);
                                    }
                                },
                                {
                                    title: "Tasks",
                                    icon: "alarm-clock",
                                    visible: !props.job.isClosed && !props.job.isCanceled,
                                    action() {
                                        if (props.onViewTasks) props.onViewTasks(props.job);
                                    }
                                },
                                {
                                    title: "Copy Job",
                                    icon: "copy",
                                    async click(e) {
                                        e.preventDefault();
                                        var res = await hub.GetAsync(API_ROUTES.Jobs + "copyjob/" + props.job.id + "/?directNumber=True")
                                        var copy = await copyToClipboard(res.data, "Job has been copied to the clipboard!");
                                        if (!copy) openCopyJob(props.job);
                                    },
                                },
                                {
                                    title: "Copy with Extension",
                                    visible: maskedAllowed,
                                    icon: "phone-office",
                                    async click(e) {
                                        e.preventDefault();
                                        var res = await hub.GetAsync(API_ROUTES.Jobs + "copyjob/" + props.job.id + "/?directNumber=False")
                                        var copy = await copyToClipboard(res.data, "Job has been copied to the clipboard!");
                                        if (!copy) openCopyJob(props.job);
                                    }
                                },
                                {
                                    title: "Duplicate",
                                    icon: "layer-plus",
                                    action() {
                                        createJob(props.job.id);
                                    }
                                },
                                {
                                    title: "Delete Job",
                                    icon: "minus-circle",
                                    danger: true,
                                    visible: hasRole("DeleteJob"),
                                    action() {
                                        deleteJobOpen(props.job);
                                    }
                                }
                            ]} />
                        </div>

                    </FlexRow>
                </div>
            }

        </div>
    )
}


export default React.memo(JobDataCard)